import styled from "styled-components";
import AppTable from "../Table/AppTable";

export const StyledInvoice = styled.div`
  background: ${({ theme }: any) =>
    theme.palette.background.default} !important;
  min-height: calc(100vh - 57px);

  .due-date {
    display: flex !important;
  }
  .due-date-print {
    display: none !important;
  }

  &.print-process {
    background: ${({ theme }: any) =>
      theme.palette.background.paper} !important;

    .invoice-buttons {
      display: none !important;
    }

    .editable-text {
      button {
        display: none !important;
      }
    }

    .ant-typography {
      .ant-typography-copy {
        display: none !important;
      }
    }

    .due-date {
      display: none !important;
    }
    .due-date-print {
      display: flex !important;
    }

    #invoice-items {
      table > colgroup > col:last-child,
      table > thead > tr:nth-child(2) > th:last-child,
      table > tbody > tr > td:last-child {
        display: none !important;
        width: 0 !important;
      }
    }

    .ant-select {
      .ant-select-selector {
        border: none !important;

        .ant-select-selection-item {
          color: ${({ theme }: { theme: any }) =>
            theme.palette.text.primary} !important;
        }
      }

      .ant-select-arrow,
      .ant-select-clear {
        display: none !important;
      }
    }

    .ant-input-number {
      border: none !important;
    }

    #invoice-price-summary {
      #invoice-add-item-button {
        display: none !important;
      }
    }

    #invoice-footer {
      display: none !important;
    }
  }
`;

export const StyledInvoiceBody = styled.div`
  background: ${({ theme }: any) => theme.palette.background.paper} !important;
  padding: 20px;
`;

export const StyledInvoiceButtons = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  justify-content: end;
  gap: 20px;

  @media print {
    display: none !important;
  }
`;

export const StyledInvoiceFooter = styled.div`
  background: ${({ theme }: any) =>
    theme.palette.background.default} !important;
  padding: 0 20px 30px 20px;
  border-top: 1px solid ${({ theme }: any) => theme.palette.primary.main} !important;

  @media print {
    display: none !important;
  }
`;

export const StyledInvoiceInfo = styled.div`
  padding: 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const StyledCloseBtn = styled.div`
  margin-left: 12px;
  padding-top: 1px;
  cursor: pointer;
`;

export const StyledAddItem = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  width: fit-content;

  @media print {
    display: none !important;
  }
`;

export const StyledInvoiceItems = styled.div`
  @media print {
    table > colgroup > col:last-child,
    table > thead > tr:nth-child(2) > th:last-child,
    table > tbody > tr > td:last-child {
      display: none !important;
      width: 0 !important;
    }
  }
`;

export const StyledSecondary = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledFlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StyledSecondaryText = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledInvoicePriceSummary = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`;

export const StyledInvoiceFooterTotalPrice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  margin-left: auto;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 40px;
  }

  .ant-descriptions-item-content {
    justify-content: end;
    display: flex;
  }
`;

export const StyledInvTable = styled(AppTable)`
  border-radius: 10px;
`;
